import i18next from "i18next";
import MultiFileUploader from "src/components/MultiFileUploader/MultiFileUploader";
import { OPPORTUNITY_SUPPORTED_FILE_TYPES } from "src/utils/constants";

export function UploadDocumentsPanel({ uploadFiles, setUploadFiles }) {

  return (
    <div>
      <div className="">
        <p className='text-muted text-center'>
          <b>
            {i18next.t('upload_rental_proposal_or_signed_documents')}
            <br />
          </b>
        </p>
        <MultiFileUploader
          files={uploadFiles}
          setFiles={setUploadFiles}
          types={OPPORTUNITY_SUPPORTED_FILE_TYPES}
        ></MultiFileUploader>
      </div>
    </div>
  )
}
